import { getTranslationFromJson } from '@patrianna/shared-utils/prismic'
import Link from 'next/link'

import ROUTES from 'config/routes.json'
import content from 'prismic-translates/page-vip.json'
import { useAppSelector } from 'src/store/hooks'
import {
  getCurrentVIPLevelPercentageSelector,
  getUserVipNextLevelName,
  getUserVipPointsLevelSelector,
} from 'store/modules/user/selectors'

import Information from './components/Information'
import Progress from './components/Progress'
import Statuses from './components/Statuses'
import VIPTable from './components/VIPTable'
import classes from './styles.module.scss'

const t = getTranslationFromJson([content])

type Props = {
  mobileDialogHandler?: () => void
}

function VIPRewards(props: Props) {
  const vipInformation = useAppSelector(getUserVipPointsLevelSelector)
  const nextLevelName = useAppSelector(getUserVipNextLevelName)
  const progressPercent = useAppSelector(getCurrentVIPLevelPercentageSelector)
  const { mobileDialogHandler } = props

  return (
    <div className={classes.root}>
      <Statuses nextLevelName={nextLevelName} currentLevelName={vipInformation?.name} />
      <Progress threshold={vipInformation.threshold} progressPercent={progressPercent} />
      <div className={classes.information}>
        <Information
          nextLevelName={nextLevelName}
          currentVipPoints={vipInformation.current}
          threshold={vipInformation.threshold}
        />
      </div>
      <VIPTable />
      <div className={classes.content}>
        <p className={`mt-typography-body1 ${classes.paragraph}`}>
          <b>{t('how_to_earn')}</b>
        </p>
        <p className='mt-typography-body1'>- {t('receive_points')}</p>
        <p className={`mt-typography-body1 ${classes.paragraph}`}>- {t('even_more')}</p>
        <p className='mt-typography-body1'>
          {t(`${process.env.BRAND_NAME}_content_description`)}!{' '}
          <Link
            href={ROUTES.TERMS}
            prefetch={false}
            onClick={() => {
              if (mobileDialogHandler) {
                mobileDialogHandler()
              }
            }}
          >
            {t('content_link')}
          </Link>
        </p>
      </div>
    </div>
  )
}

export default VIPRewards
